import { GetCurrentLoginInformationsOutput } from '@/shared';
import { IAbp } from '@/shared/abp/interfaces';
import { abpStore_NS, rootStore } from '@/shared/store';

class AbpService {
    public set(val: any) {
        rootStore.commit(`${abpStore_NS}/set`, val);
    }

    get abp(): IAbp {
        const storeAbp = rootStore.getters[`${abpStore_NS}/get`];
        if (storeAbp.localization) {
            return storeAbp;
        }
        return abp as any;
    }

    public setModuleKey(val: any) {
        rootStore.commit(`${abpStore_NS}/setModuleKey`, val);
    }

    get moduleKey(): string {
        return rootStore.getters[`${abpStore_NS}/moduleKey`];
    }

    public setLoginInfo(val: GetCurrentLoginInformationsOutput) {
        rootStore.commit(`${abpStore_NS}/setLoginInfo`, val);
    }

    get loginInfo(): GetCurrentLoginInformationsOutput {
        return rootStore.getters[`${abpStore_NS}/getLoginInfo`];
    }

    get tabincludes(): string[] {
        return rootStore.getters[`${abpStore_NS}/tabincludes`];
    }
    public addInclude(include: string) {
        rootStore.commit(`${abpStore_NS}/addInclude`, include);
    }
    public removeInclude(include: string) {
        rootStore.commit(`${abpStore_NS}/removeInclude`, include);
    }
    public clearInclude() {
        rootStore.commit(`${abpStore_NS}/clearInclude`);
    }
}

const abpService = new AbpService();
export default abpService;
